export interface RushOrders {
  priorityCount: number;
  waitingForPayment: number;
  processing: number;
  processingOlderThan10Min: number;
  cooking: number;
  waitingForRider: number;
  driverAssigned: number;
  deliveryCollected: number;
  deliveryCollected40to50: number;
  deliveryCollected50to60: number;
  deliveryCollected60to90: number;
  deliveryCollected90to120: number;
  deliveryCollectedOver120: number;
}

export enum RushOrderLabels {
  priorityCount = "Priorité",
  waitingForPayment = "En attente de paiement",
  processing = "En attente",
  processingOlderThan10Min = "En attente >10 min",
  cooking = "En cours de préparation",
  waitingForRider = "Recherche livreur",
  driverAssigned = "En route restaurant",
  deliveryCollected = "En route client",
  deliveryCollected40to50 = "40–50 min",
  deliveryCollected50to60 = "50–60 min",
  deliveryCollected60to90 = "60–90 min",
  deliveryCollected90to120 = "90–120 min",
  deliveryCollectedOver120 = ">120 min",
}

export enum RushOrderColors {
  priorityCount = "bg-red-500",
  waitingForPayment = "bg-rose-400",
  processing = "bg-yellow-400",
  processingOlderThan10Min = "bg-yellow-600",
  cooking = "bg-orange-400",
  waitingForRider = "bg-blue-400",
  driverAssigned = "bg-indigo-400",
  deliveryCollected = "bg-green-400",
  deliveryCollected40to50 = "bg-green-500",
  deliveryCollected50to60 = "bg-green-600",
  deliveryCollected60to90 = "bg-green-700",
  deliveryCollected90to120 = "bg-green-800",
  deliveryCollectedOver120 = "bg-green-900",
}
